import { useDialog, useRecordEvent } from "app/hook";
import { DialogType, AnalyticsEventType } from "app/types";
import I18n from "common/i18n";
import { btnDelay, useScale, usePlaySound } from "common/utils";
import { usePlan, PlanType } from "features/subscription";

export const ParentGateButton = () => {
  const play = usePlaySound();
  const plan = usePlan();
  const { scale } = useScale();
  const handleDialog = useDialog();
  const handleRecordEvent = useRecordEvent();

  // 体験プランはボタン自体を非表示
  if (plan === PlanType.TRIAL) return null;

  const handleOpenParentSetting = () => {
    btnDelay(() => {
      play();

      handleDialog({ type: DialogType.PARENT_GATE, value: true });
      handleRecordEvent(AnalyticsEventType.PARENT_GATE_BTN_CLICK);
    });
  };

  return (
    <div
      className="flex-col-el z-[1000] absolute alpha origin-right"
      style={{
        bottom: 30 * scale,
        right: 16 * scale,
        transform: `scale(${scale})`,
      }}
    >
      <button className="btn btn-danger" onClick={handleOpenParentSetting}>
        <div className="flex-row-el flex-center gap-2 relative mb-[3px]">
          <span className="material-symbols-outlined !text-4xl">admin_panel_settings</span>
          <p className="text-body text-white text-[36px]">{I18n.t("MSG_SETTING_PARENT_GATE")}</p>
        </div>
      </button>
    </div>
  );
};
